import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../App";
import { Film, ChevronRight, AlertTriangle } from "lucide-react";

const STAGE_COLORS = { request: "#64748B", script: "#8B5CF6", approval: "#F59E0B", pre_production: "#06B6D4", shoot: "#E31937", edit: "#EC4899", client_review: "#3B82F6", delivered: "#22C55E" };

export default function ProductionProjects() {
  const navigate = useNavigate();
  const [productions, setProductions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("");

  useEffect(() => { loadProds(); }, [filter]);
  const loadProds = async () => { try { const url = filter ? `/productions?status=${filter}` : "/productions"; setProductions((await api.get(url)).data); } catch (e) { console.error(e); } finally { setLoading(false); } };

  if (loading) return <><div className="flex items-center justify-center h-64"><div className="animate-pulse text-amber-400 font-heading text-xl">LOADING...</div></div></>;

  return (
    <>
      <div data-testid="production-projects" className="space-y-5">
        <h1 className="font-heading text-2xl sm:text-3xl text-[var(--t1)] tracking-tight">PROJECTS</h1>
        <div className="flex flex-wrap gap-2">
          {["", "active", "completed", "on_hold"].map(f => (
            <button key={f} onClick={() => setFilter(f)} className={`px-3 py-1.5 rounded-full text-xs font-medium transition-all ${filter === f ? "bg-amber-500 text-black" : "text-[var(--t3)] bg-[var(--s2)] border border-[var(--bdr)] hover:bg-[var(--s3)]"}`}>
              {f || "All"}
            </button>
          ))}
        </div>
        <div className="space-y-3">
          {productions.length === 0 ? (
            <div className="text-center py-16"><Film size={40} className="mx-auto text-white/10 mb-4" /><p className="text-[var(--t3)] text-sm">No productions yet. Create a film request from Biz Dev to start.</p></div>
          ) : (
            productions.map(p => (
              <button key={p.production_id} onClick={() => navigate(`/production/projects/${p.production_id}`)} className="w-full text-left glass-card rounded-2xl p-5 candidate-editorial group" data-testid={`prod-${p.production_id}`}>
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 min-w-0">
                    <p className="text-white font-semibold text-base normal-case">{p.title}</p>
                    <p className="text-[var(--t3)] text-xs normal-case mt-0.5">{p.client_name} {p.deadline ? `| Due: ${p.deadline}` : ""}</p>
                    <div className="flex items-center gap-2 mt-2">
                      <span className="text-[12px] px-2 py-0.5 rounded-full capitalize" style={{ backgroundColor: (STAGE_COLORS[p.current_stage] || "#666") + "15", color: STAGE_COLORS[p.current_stage] || "#666" }}>
                        {(p.current_stage || "").replace(/_/g, " ")}
                      </span>
                      {p.deliverables_count > 0 && <span className="text-[12px] text-white/20">{p.deliverables_completed || 0}/{p.deliverables_count} delivered</span>}
                      {p.delivery_risk_score > 0.5 && <span className="flex items-center gap-0.5 text-[12px] text-red-400"><AlertTriangle size={10} />{Math.round(p.delivery_risk_score * 100)}% risk</span>}
                    </div>
                  </div>
                  <ChevronRight size={16} className="text-white/10 group-hover:text-[var(--t3)] transition-colors mt-1" />
                </div>
              </button>
            ))
          )}
        </div>
      </div>
    </>
  );
}
